import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CmsBodyDirective } from '../../directives/cms-body.directive';
import { Reference } from '../../models';
import { transformVimeoEmbedsInHtml } from '../../utils/vimeo-embed.util';

@Component({
  selector: 'prime-cms-body',
  standalone: true,
  imports: [CommonModule, CmsBodyDirective],
  template: `
    <ng-container [ngSwitch]="tag">
      <p
        *ngSwitchCase="'p'"
        primeCmsBody
        [references]="references"
        [class]="hostClass"
        [ngClass]="hostNgClass"
        [innerHTML]="resolvedContent"
      ></p>
      <span
        *ngSwitchCase="'span'"
        primeCmsBody
        [references]="references"
        [class]="hostClass"
        [ngClass]="hostNgClass"
        [innerHTML]="resolvedContent"
      ></span>
      <div
        *ngSwitchDefault
        primeCmsBody
        [references]="references"
        [class]="hostClass"
        [ngClass]="hostNgClass"
        [innerHTML]="resolvedContent"
      ></div>
    </ng-container>
  `,
})
export class CmsBodyComponent implements OnChanges {
  @Input() content: string | SafeHtml = '';
  @Input() references: Reference[] = [];
  @Input() tag: 'div' | 'p' | 'span' = 'div';
  @Input() hostClass = '';
  @Input() hostNgClass:
    | string
    | Set<string>
    | Record<string, boolean> = '';

  resolvedContent: SafeHtml = '';

  constructor(private sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['content']) {
      this.resolvedContent = this.buildResolvedContent();
    }
  }

  private buildResolvedContent(): SafeHtml {
    if (typeof this.content !== 'string') {
      return this.content || this.sanitizer.bypassSecurityTrustHtml('');
    }

    return this.sanitizer.bypassSecurityTrustHtml(
      transformVimeoEmbedsInHtml(this.content)
    );
  }
}
